import { useEffect, useState, ChangeEvent } from 'react';
import Cookies from 'universal-cookie';
import InputField from './InputField';
import { CollasableCard } from './Cards';
import MaltInput from './MaltInput';
import HoverButton from './HoverButton';
import ColorIndicator from './ColorIndicator';
import HopInput from './HopInput';
import { useTranslation } from 'react-i18next';

const cookies = new Cookies();

interface Malt {
  Id: number;
  Name: string;
  Weight: number | string;
  Extract: number | string;
  Color: number | string;
}

interface Hop {
  Id: number;
  Name: string;
  Weight: number | string;
  Acid: number | string;
  Time: number | string;
}

interface UtilEntry {
  t: number;
  v: number;
}

interface ColorEntry {
  srm: number;
  r: number;
  g: number;
  b: number;
}

const defaultMalts: Malt[] = [
  { Id: 0, Name: 'Pilzneński', Weight: 1.5, Extract: 82.6, Color: 4 },
  { Id: 1, Name: 'Pszeniczny', Weight: 2.5, Extract: 82.2, Color: 4 },
  { Id: 2, Name: 'Karmelowy jasny', Weight: 0.25, Extract: 75.9, Color: 25 },
];

const defaultHops: Hop[] = [
  { Id: 0, Name: 'Chmiel 1', Weight: 10, Acid: 8.5, Time: 60 },
  { Id: 1, Name: 'Chmiel 2', Weight: 10, Acid: 8.5, Time: 30 },
  { Id: 2, Name: 'Chmiel 3', Weight: 30, Acid: 3.8, Time: 15 },
];

const Util: UtilEntry[] = [
  {t:0,v:5},{t:1,v:5.11},{t:2,v:5.22},{t:3,v:5.33},{t:4,v:5.44},{t:5,v:5.56},
  {t:6,v:5.67},{t:7,v:5.78},{t:8,v:5.89},{t:9,v:6},{t:10,v:7.5},{t:11,v:9},
  {t:12,v:10.5},{t:13,v:12},{t:14,v:13.5},{t:15,v:15},{t:16,v:15.4},{t:17,v:15.8},
  {t:18,v:16.2},{t:19,v:16.6},{t:20,v:17},{t:21,v:17.4},{t:22,v:17.8},{t:23,v:18.2},
  {t:24,v:18.6},{t:25,v:19},{t:26,v:19.42},{t:27,v:19.83},{t:28,v:20.25},{t:29,v:20.67},
  {t:30,v:21.08},{t:31,v:21.5},{t:32,v:21.92},{t:33,v:22.33},{t:34,v:22.75},{t:35,v:23.17},
  {t:36,v:23.58},{t:37,v:24},{t:38,v:24.2},{t:39,v:24.4},{t:40,v:24.6},{t:41,v:24.8},
  {t:42,v:25},{t:43,v:25.2},{t:44,v:25.4},{t:45,v:25.6},{t:46,v:25.8},{t:47,v:26},
  {t:48,v:26.2},{t:49,v:26.4},{t:50,v:26.6},{t:51,v:26.8},{t:52,v:27},{t:53,v:27.38},
  {t:54,v:27.75},{t:55,v:28.13},{t:56,v:28.5},{t:57,v:28.88},{t:58,v:29.25},{t:59,v:29.63},
  {t:60,v:30},{t:61,v:30.27},{t:62,v:30.53},{t:63,v:30.8},{t:64,v:31.07},{t:65,v:31.33},
  {t:66,v:31.6},{t:67,v:31.87},{t:68,v:32.13},{t:69,v:32.4},{t:70,v:32.67},{t:71,v:32.93},
  {t:72,v:33.2},{t:73,v:33.47},{t:74,v:33.73},{t:75,v:34},
];

const colorLUT: ColorEntry[] = [
  {srm:1,r:255,g:230,b:153},{srm:2,r:255,g:216,b:120},{srm:3,r:255,g:202,b:90},
  {srm:4,r:255,g:191,b:66},{srm:5,r:251,g:177,b:35},{srm:6,r:248,g:166,b:0},
  {srm:7,r:243,g:156,b:0},{srm:8,r:234,g:143,b:0},{srm:9,r:229,g:133,b:0},
  {srm:10,r:222,g:124,b:0},{srm:11,r:215,g:114,b:0},{srm:12,r:207,g:105,b:0},
  {srm:13,r:203,g:98,b:0},{srm:14,r:195,g:89,b:0},{srm:15,r:187,g:81,b:0},
  {srm:16,r:181,g:76,b:0},{srm:17,r:176,g:69,b:0},{srm:18,r:166,g:62,b:0},
  {srm:19,r:161,g:55,b:0},{srm:20,r:155,g:50,b:0},{srm:21,r:149,g:45,b:0},
  {srm:22,r:142,g:41,b:0},{srm:23,r:136,g:35,b:0},{srm:24,r:130,g:30,b:0},
  {srm:25,r:123,g:26,b:0},{srm:26,r:119,g:25,b:0},{srm:27,r:112,g:20,b:0},
  {srm:28,r:106,g:14,b:0},{srm:29,r:102,g:13,b:0},{srm:30,r:94,g:11,b:0},
  {srm:31,r:90,g:10,b:2},{srm:32,r:96,g:9,b:3},{srm:33,r:82,g:9,b:7},
  {srm:34,r:76,g:5,b:5},{srm:35,r:71,g:6,b:6},{srm:36,r:68,g:6,b:7},
  {srm:37,r:63,g:7,b:8},{srm:38,r:59,g:6,b:7},{srm:39,r:58,g:7,b:11},
  {srm:40,r:54,g:8,b:10},{srm:41,r:20,g:4,b:2},
];

function calcUtilization(time: number | string): number {
  const t = Math.max(0, Math.min(75, Math.round(Number(time))));
  const entry = Util.find(c => c.t === t);
  return entry ? entry.v : 5;
}

function calcEBC2RGB(ebc: number): string {
  const srm = Math.round(ebc * 0.508);
  const entry = colorLUT.find(c => c.srm === srm);
  if (!entry) return '255,255,255';
  return `${entry.r},${entry.g},${entry.b}`;
}

function calcMaltsWeight(malts: Malt[]): number {
  return malts.reduce((a, b) => a + parseFloat(String(b.Weight)), 0);
}

function calcBlg(malts: Malt[], efficiency: number | string, volume: number | string): number {
  const realExtract = malts.reduce((a, b) => a + Number(b.Weight) * Number(b.Extract) * Number(efficiency) / 10.0, 0);
  const realExtract_ml = realExtract / 1.587;
  const water_ml = Number(volume) * 1000 - realExtract_ml;
  return 100 * realExtract / (water_ml + realExtract);
}

function calcEBC(malts: Malt[], volume: number | string): number {
  const colorSum = malts.reduce((a, b) => a + (Number(b.Weight) * 2.20462262184878) * (Number(b.Color) / 1.97), 0);
  const colorSumVolume = colorSum / (Number(volume) / 3.78541178);
  const ebc = Math.pow(colorSumVolume, 0.6859) * 1.4922 * 1.97;
  return Math.min(ebc, 80);
}

function calcIBU(weight: number | string, acid: number | string, time: number | string, hotWorthVolume: number | string): number {
  return Number(weight) * Number(acid) * calcUtilization(time) / (Number(hotWorthVolume) * 10);
}

export default function Recipe() {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = t('recipe.pageTitle');
  }, [t]);

  const [hotWorthVolume, setHotWorthVolume] = useState<string | number>(cookies.get('recipe.hotWorthVolume') || 24.0);
  const [recipeEfficiency, setRecipeEfficiency] = useState<string | number>(cookies.get('recipe.recipeEfficiency') || 80.0);
  const [malts, setMalts] = useState<Malt[]>(defaultMalts);
  const [maltId, setMaltId] = useState(Math.max(...defaultMalts.map(m => m.Id)));
  const [hops, setHops] = useState<Hop[]>(defaultHops);
  const [hopId, setHopId] = useState(Math.max(...defaultHops.map(h => h.Id)));

  function handleRecipeChange(event: ChangeEvent<HTMLInputElement>) {
    const { name, value } = event.target;
    if (name === 'hotWorthVolume') { cookies.set('recipe.hotWorthVolume', value); setHotWorthVolume(value); }
    if (name === 'recipeEfficiency') { cookies.set('recipe.recipeEfficiency', value); setRecipeEfficiency(value); }
  }

  function handleMaltChange(event: ChangeEvent<HTMLInputElement>, Id: number) {
    const { name, value } = event.target;
    setMalts(prev => prev.map(m => m.Id === Id ? { ...m, [name]: value } : m));
  }

  function handleHopChange(event: ChangeEvent<HTMLInputElement>, Id: number) {
    const { name, value } = event.target;
    setHops(prev => prev.map(h => h.Id === Id ? { ...h, [name]: value } : h));
  }

  function appendMalt() {
    const newId = maltId + 1;
    setMalts(prev => [...prev, { Id: newId, Name: 'Słód', Weight: 0, Extract: 80, Color: 7 }]);
    setMaltId(newId);
  }

  function removeMalt(Id: number) {
    setMalts(prev => prev.filter(m => m.Id !== Id));
  }

  function appendHop() {
    const newId = hopId + 1;
    setHops(prev => [...prev, { Id: newId, Name: 'Chmiel', Weight: 0, Acid: 5, Time: 60 }]);
    setHopId(newId);
  }

  function removeHop(Id: number) {
    setHops(prev => prev.filter(h => h.Id !== Id));
  }

  const maltsWeight = calcMaltsWeight(malts);
  const blg = calcBlg(malts, recipeEfficiency, hotWorthVolume);
  const ebc = calcEBC(malts, hotWorthVolume);
  const ibu = hops.reduce((a, h) => a + calcIBU(h.Weight, h.Acid, h.Time, hotWorthVolume), 0);
  const ibu_to_blg = ibu / blg;

  let bitternessKey = '';
  if (ibu_to_blg < 1.5) bitternessKey = 'recipe.bitterness1';
  else if (ibu_to_blg < 3) bitternessKey = 'recipe.bitterness2';
  else if (ibu_to_blg < 4) bitternessKey = 'recipe.bitterness3';
  else bitternessKey = 'recipe.bitterness4';

  return (
    <div>
      <CollasableCard title={t('recipe.wortParams')}>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <InputField name="hotWorthVolume" label={t('recipe.hotWortVolume')} step="0.1" value={hotWorthVolume} unit="L" onChange={handleRecipeChange} />
          <InputField name="recipeEfficiency" label={t('recipe.mashEfficiency')} step="1" value={recipeEfficiency} unit="%" onChange={handleRecipeChange} />
        </div>
      </CollasableCard>

      <CollasableCard title={t('recipe.malts')}>
        <div className="hidden sm:grid grid-cols-6 gap-2 mb-2 text-xs font-medium text-muted-foreground">
          <span>{t('recipe.maltName')}</span>
          <span>{t('recipe.maltWeight')}</span>
          <span>{t('recipe.maltExtract')}</span>
          <span>{t('recipe.maltColor')}</span>
          <span>{t('recipe.maltContent')}</span>
          <span></span>
        </div>
        {malts.map(malt => (
          <MaltInput
            key={malt.Id}
            Id={malt.Id}
            Name={String(malt.Name)}
            Weight={malt.Weight}
            Extract={malt.Extract}
            Color={malt.Color}
            Content={(100 * Number(malt.Weight) / maltsWeight).toFixed(1)}
            removeMalt={removeMalt}
            handleInputChange={handleMaltChange}
          />
        ))}
        <HoverButton onClick={appendMalt} text={t('recipe.addMalt')} hoveredIcon="fa-plus-circle" normalIcon="fa-plus" />
      </CollasableCard>

      <CollasableCard title={t('recipe.hops')}>
        <div className="hidden sm:grid grid-cols-6 gap-2 mb-2 text-xs font-medium text-muted-foreground">
          <span>{t('recipe.hopName')}</span>
          <span>{t('recipe.hopWeight')}</span>
          <span>{t('recipe.hopAlpha')}</span>
          <span>{t('recipe.hopTime')}</span>
          <span>{t('recipe.hopIbu')}</span>
          <span></span>
        </div>
        {hops.map(hop => (
          <HopInput
            key={hop.Id}
            Id={hop.Id}
            Name={String(hop.Name)}
            Weight={hop.Weight}
            Acid={hop.Acid}
            Time={hop.Time}
            IBU={calcIBU(hop.Weight, hop.Acid, hop.Time, hotWorthVolume).toFixed(1)}
            removeHop={removeHop}
            handleInputChange={handleHopChange}
          />
        ))}
        <HoverButton onClick={appendHop} text={t('recipe.addHop')} hoveredIcon="fa-plus-circle" normalIcon="fa-plus" />
      </CollasableCard>

      <CollasableCard title={t('recipe.wortResult')}>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
          <InputField name="blg" label={t('recipe.wortGravity')} value={blg.toFixed(1)} unit="%" readOnly />
          <InputField name="ibu" label={t('recipe.wortBitterness')} value={ibu.toFixed(1)} unit="IBU" readOnly />
          <InputField name="ebc" label={t('recipe.wortColor')} value={ebc.toFixed(0)} unit="EBC" readOnly />
          <InputField name="ibuRatio" label={t('recipe.ibuRatio')} value={ibu_to_blg.toFixed(1)} readOnly />
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <label className="block text-xs font-medium text-muted-foreground mb-1">{t('recipe.colorLabel')}</label>
            <ColorIndicator color={calcEBC2RGB(ebc)} />
          </div>
          <div>
            <label className="block text-xs font-medium text-muted-foreground mb-1">{t('recipe.bitternessLabel')}</label>
            <p className="text-sm text-foreground">{t(bitternessKey)}</p>
          </div>
        </div>
      </CollasableCard>
    </div>
  );
}
